<!-- swiper secondPage -->
<template>
  <div class="cont-g" :style="{ height: statusH + 'px' }">
    <div class="cont-top">
      <div class="cont-top-c">
        <div class="check-g limit-width">
          <div class="check-s">
            <div class="cont-fix">Чек №{{ order.localId }}</div>
            <template v-if="hasGuestGroups">
              <div
                v-for="(group, guestNum) in groupedGuests"
                :key="guestNum"
                class="guest-block"
              >
                <h3 class="guest-title">Гість {{ guestNum }}</h3>
                <currentSwiper
                  v-for="product in group.products"
                  :key="product.uniqueId"
                  :product="product"
                  :rozdilit="rozdilit"
                  :currentProduct="
                    productsForRozdilit[product.uniqueId] || {
                      is: false,
                      count: 0,
                    }
                  "
                />
                <div class="guest-total">
                  <strong>Всього з гостя {{ guestNum }}</strong>
                  {{ group.total.toFixed(2) }} ₴
                </div>
              </div>
            </template>

            <template v-else>
              <currentSwiper
                v-for="product in order.products"
                :key="product.uniqueId"
                :product="product"
                :rozdilit="rozdilit"
                :currentProduct="
                  productsForRozdilit[product.uniqueId] || {
                    is: false,
                    count: 0,
                  }
                "
              />
            </template>

            <div
              v-if="order.discountSum > 0"
              class="product-gSwiper product-pidsumok discount"
            >
              <div class="product-l">
                <p>Знижка</p>
              </div>
              <div class="product-r">-{{ order.discountSum }}₴</div>
            </div>

            <div class="product-gSwiper product-pidsumok">
              <div class="product-l">
                <p>Підсумок</p>
              </div>
              <div class="product-r">{{ order.sum }}₴</div>
            </div>
            <!-- статус -->
            <!-- <div v-if="order && order.status && order.status !== 'new'" class="order-status-elevated"
              :class="order.status">
              {{ getOrderStatusText(order.status) }}
            </div> -->

            <!-- !!!!!!! -->
            <div
              v-if="!rozdilit && isCanRozdilit && true"
              class="rozdiliti"
              @click="rozdilitiCheck"
            >
              Розділити рахунок
            </div>
            <div v-if="splitError" class="rozdiliti erorRozdilit">
              <svg
                class="icon-check"
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="11"
                  stroke="#BDBDBD"
                  stroke-width="2"
                  fill="none"
                />
                <path
                  d="M8 8 L16 16 M16 8 L8 16"
                  fill="none"
                  stroke="#BDBDBD"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              {{ splitError }}
            </div>
            <div
              v-if="rozdilit && isCanRozdilit && true"
              class="rozdiliti"
              style="color: red"
              @click="cancelChek"
            >
              Скасувати
            </div>
            <!-- !!!!! -->
            <div class="line"></div>
            <div
              v-if="!isOverPaymentLimit"
              class="product-gSwiper product-splata"
            >
              <div class="product-l">
                <p>До сплати</p>
              </div>
              <div
                class="product-r"
                :class="{ 'line-through': prepaymentsDatas[order.id] }"
              >
                {{ order.sum }}₴
              </div>
              <!-- Якщо була предплата -->
              <div class="product-r" v-if="prepaymentsDatas[order.id]">
                {{ formatPrice(order.sum - prepaymentsDatas[order.id]) }}₴
              </div>
            </div>
          </div>
          <!-- Договір платника. Показуємо завжди, коли є платіжка: гість укладає його
               натисканням «Сплатити», тож посилання не можна ховати за лімітом суми. -->
          <a
            v-if="paymentTermsLink"
            class="rules link"
            :href="paymentTermsLink"
            target="_blank"
            rel="noopener noreferrer"
          >
            Продовжуючи, ви приймаєте правила сервісу</a
          >
          <!-- Знаки Visa/Mastercard — там само, де гість вирішує платити.
               Умова та сама, що в договору платника: обидва мають сенс лише
               коли онлайн-оплата взагалі є. -->
          <CardBrandsMark v-if="paymentTermsLink" class="card-brands-row" />
        </div>
      </div>
    </div>
    <div class="cont-bottom">
      <button
        @click="splitBill"
        class="cont-bottom-btn limit-width"
        v-if="rozdilit"
      >
        Розділити
      </button>
      <!-- Як у скроловій верстці: понад ліміт кнопка сама стає повідомленням.
           Це ліміт платіжного сервісу на онлайн-операцію, а не обмеження суми
           чека — у закладі такий рахунок оплатити можна. -->
      <button
        v-else
        :disabled="isPayDisabled"
        :style="{ opacity: payButtonOpacity }"
        class="cont-bottom-btn limit-width"
        @click="payInvoice(order.id, order.sum)"
      >
        <template v-if="isOverPaymentLimit">
          Ліміт онлайн-оплати — {{ paymentLimit }} грн
        </template>
        <template v-else>Сплатити рахунок</template>
      </button>
    </div>
  </div>
</template>

<script>
import { store } from "@/store.js";
import { createUrlForReview } from "@/utils/urlReviews";
import {
  getPaymentTermsLink,
  ONLINE_PAYMENT_LIMIT,
  ONLINE_PAYMENT_LIMIT_LABEL,
} from "@/utils/paymentTerms";
import { sendSocketTypayGuest } from "../tpayConnect";
import currentSwiper from "./currentSwiper.vue";
import CardBrandsMark from "@/components/CardBrandsMark.vue";

export default {
  props: [
    "order",
    "orders",
    "paymentType",
    "uuidGets",
    "isActiveReviews",
    "onRefresh",
  ],
  data() {
    return {
      statusH: window.innerHeight - 95,
      productsForRozdilit: this.order.products.reduce((acum, product) => {
        const id = product.uniqueId;
        acum[id] = {
          is: false,
          count: product.count,
          id,
        };
        return acum;
      }, {}),

      rozdilit: false,
      splitError: "",
    };
  },
  components: {
    currentSwiper,
    CardBrandsMark,
  },
  watch: {
    order: {
      handler(newVal, oldVal) {
        if (oldVal && oldVal.products && newVal && newVal.products) {
          newVal.products.forEach((product) => {
            const id = product.uniqueId;
            const existing = this.productsForRozdilit[id];
            if (!existing) {
              this.productsForRozdilit[id] = {
                is: false,
                count: product.count,
                id,
              };
            } else {
              this.productsForRozdilit[id].count = 1;
              this.productsForRozdilit[id].is = false;
            }
          });
        }
      },
      immediate: true, // якщо треба одразу при mount
      deep: true, // якщо `order` — об'єкт з вкладеними даними
    },
  },

  methods: {
    payInvoice(orderId) {
      this.$emit("startLoader");
      const prepaymentData = this.prepaymentsDatas[orderId];

      const messageSend = {
        action: "createInvoice",
        qrToken: `${store.tpayId}`,
        uuidGuest: this.uuidGets,
        payment: {
          paymentSystem: this.paymentType,
          invoice: {
            id: orderId,
          },
        },
      };

      // Додаємо resultUrl, якщо активні відгуки
      if (this.isActiveReviews) {
        messageSend.resultUrl = createUrlForReview();
      }
      sendSocketTypayGuest(messageSend, prepaymentData);
    },

    splitBill() {
      this.splitError = ""; // Очистити повідомлення про помилки
      const data = [];
      const orderProducts = this.order.products;

      let fullySplitCount = 0;
      let totalSelected = 0;
      let errorProducts = [];

      for (let i = 0; i < orderProducts.length; i++) {
        const product = orderProducts[i];
        const id = product.uniqueId;
        const prod = this.productsForRozdilit[id];

        if (prod && prod.is && prod.count > 0) {
          totalSelected++;

          const isFullySelected = prod.count >= product.count;

          if (isFullySelected) {
            fullySplitCount++;
            errorProducts.push(product.nomenclatureName);
          }

          data.push({
            nomenclatureId: product.nomenclatureId,
            nomenclatureName: product.nomenclatureName,
            finalAmount: product.finalAmount,
            nomenclatureUnit: product.nomenclatureUnit,
            uniqueId: product.uniqueId,
            price: product.price,
            count: prod.count,
          });
        }
      }

      if (!data.length) {
        this.splitError = "Не обрано жодного товару для розділення";
        setTimeout(() => {
          this.splitError = "";
        }, 10000);
        return;
      }

      if (
        fullySplitCount === totalSelected &&
        totalSelected === this.order.products.length
      ) {
        this.splitError = `Неможливо повністю розділити всі товари`;
        setTimeout(() => {
          this.splitError = "";
        }, 10000);
        return;
      }

      const messageSend = {
        action: "splitBill",
        qrToken: `${store.tpayId}`,
        uuidGuest: this.uuidGets,
        data: {
          id: this.order.id,
          products: data,
        },
      };

      sendSocketTypayGuest(messageSend);
      this.$emit("startLoader");

      setTimeout(() => {
        this.onRefresh();
      }, 600);
    },

    // Форматування ціни
    formatPrice(price) {
      return Number(price).toFixed(2);
    },
    rozdilitiCheck() {
      this.rozdilit = !this.rozdilit;
    },
    add(id) {
      this.productsForRozdilit[id].count++;
    },
    minus(id) {
      this.productsForRozdilit[id].count--;
    },
    cancelChek() {
      this.rozdilit = false;
    },
    getOrderStatusText(status) {
      switch (status) {
        case "prepare":
          return "🍳 Готується";
        case "ready":
          return "📦 Замовлення готове — заберіть його!";
        case "done":
          return "🎉 Замовлення завершено. Смачного!";
        default:
          return status;
      }
    },
  },

  computed: {
    prepaymentsDatas() {
      const datas = {};
      this.orders.forEach((order) => {
        if (!order.prepaymentData) return;
        const prepaymentData = Object.values(order.prepaymentData);
        const sum = prepaymentData.reduce((acum, elem) => acum + +elem.sum, 0);
        if (!order.id) return;
        datas[order.id] = sum;
      });
      return datas;
    },
    // Договір платника обраної платіжної системи
    paymentTermsLink() {
      return getPaymentTermsLink(this.paymentType);
    },
    paymentLimit() {
      return ONLINE_PAYMENT_LIMIT_LABEL;
    },
    // Блокуємо, тільки якщо сума ПЕРЕВИЩУЄ ліміт: рівно на ліміті платити можна.
    isOverPaymentLimit() {
      return this.order.sum > ONLINE_PAYMENT_LIMIT;
    },
    isPayDisabled() {
      return (
        this.isOverPaymentLimit ||
        this.order.sum - this.prepaymentsDatas[this.order.id] <= 0
      );
    },
    // 0.65 — те саме приглушення, що Bootstrap дає заблокованій кнопці у
    // скроловій верстці (.btn:disabled). Так обидва варіанти чека виглядають
    // однаково. Інші причини блокування лишаємо на попередніх 0.5.
    payButtonOpacity() {
      if (this.isOverPaymentLimit) return 0.65;
      return this.isPayDisabled ? 0.5 : 1;
    },
    isCanRozdilit() {
      const products = this.order.products;
      switch (products.length) {
        case 0:
          return false;
        case 1:
          return products[0].count != 1;
        default:
          return true;
      }
    },
    hasGuestGroups() {
      return this.order.products?.some(
        (p) => typeof p.guestGroup !== "undefined"
      );
    },
    groupedGuests() {
      const groups = {};
      (this.order.products || []).forEach((p) => {
        const guestIndex = (p.guestGroup || 0) + 1;
        if (!groups[guestIndex]) {
          groups[guestIndex] = {
            products: [],
            total: 0,
          };
        }
        groups[guestIndex].products.push(p);
        groups[guestIndex].total += Number(p.finalAmount || p.price || 0);
      });
      return groups;
    },
  },
};
</script>

<style scoped>
#app-slider {
  height: 100%;
}

.cont-g {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.limit-width {
  width: 90%;
  max-width: 450px;
}

.cont-fix {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  color: black;
  font-weight: bold;
  color: var(--text-innerBody) !important;
}

.cont-top {
  /* background-color: rgb(245, 245, 245); */
  background: var(--innerBody) !important;
  width: 100%;
  height: calc(100% - 125px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.cont-top-c {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* Для плавного скролу на старих пристроях */
}

.check-g {
  padding-top: 20px;
  color: black;
}

.check-s {
  padding: 15px;
  background-color: rgb(255, 255, 255);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 5px 1px 5px #b9b9b9;

  padding-bottom: 20px;
  --mask: radial-gradient(7px at 50% calc(100% - 9.6px), #000 99%, #0000 101%)
      calc(50% - 12px) 0/24px 100%,
    radial-gradient(7px at 50% calc(100% + 3.6px), #0000 99%, #000 101%) 50%
      calc(100% - 6px) / 24px 100% repeat-x;
  -webkit-mask: var(--mask);
  mask: var(--mask);
  /* margin-bottom: 20px; */
  background: var(--content) !important;
  color: var(--text-innerBody) !important;
}

.cont-bottom {
  padding: 45px 0 0 0;
  /* height: 105px; */
  /* 145, а не 125: у футер додався рядок «Умови користування», і фіксована
     смуга внизу підросла — інакше вона наїжджає на кнопку оплати. */
  height: 145px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  background: var(--footer) !important;
}

.cont-bottom-btn {
  padding: 15px 0;
  /* background-color: #28a745; */
  background: var(--button) !important;
  border: 1px solid var(--button) !important;
  color: var(--text-button) !important;

  /* color: white; */
  border-radius: 10px;
  font-weight: bold;
}

.product-gSwiper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* padding-bottom: 10px; */
}

.product-r {
  display: flex;
  font-style: italic;
}

.product-count {
  /* color: #28a745; */
  color: var(--text-content) !important;

  padding-right: 5px;
}

.line-punk {
  margin: 35px 0;
  border: 1px dashed rgb(244, 244, 244);
}

.line {
  margin: 20px 0;
  border: 1px solid rgb(244, 244, 244);
}

.product-l {
  display: flex;
}

.product-pidsumok {
  margin: 10px 0;
}

.product-splata {
  font-weight: bold;
}

.link {
  text-decoration: none;
}

.rules {
  display: flex;
  justify-content: center;
  opacity: 0.5;
  font-size: 10px;
  color: var(--text-footer) !important;
}

.card-brands-row {
  margin-top: 8px;
}


/* Доплата */
.line-through {
  text-decoration: line-through;
  /* Додає перекреслення */
  opacity: 0.7;
}

.discount {
  /* font-style: oblique 20deg; */
  font-weight: 500;
  margin: 10px 0;
  font-size: 12px;
}

.rozdiliti {
  width: 100%;
  color: #49b461;
  display: flex;
  justify-content: center;
  align-items: center;
}

.order-status-elevated {
  margin: 20px auto;
  padding: 14px 20px;
  max-width: 90%;
  text-align: center;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
  backdrop-filter: blur(6px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.04);
  transition: none;
  border-left: 4px solid transparent;
}

/* СТИЛІ ДЛЯ СТАТУСІВ */
.order-status-elevated.prepare {
  background: linear-gradient(90deg, #fff8e1, #ffecb3);
  color: #a16200;
  border-left-color: #ffc107;
}

.order-status-elevated.ready {
  background: linear-gradient(90deg, #e8f5e9, #c8e6c9);
  color: #2e7d32;
  border-left-color: #4caf50;
}

.order-status-elevated.done {
  background: linear-gradient(90deg, #e3f2fd, #bbdefb);
  color: #0d47a1;
  border-left-color: #2196f3;
}

.erorRozdilit {
  color: #bdbdbd;
  gap: 5px;
  font-size: 12px;
}
</style>
